(() => {
  const apiName = 'InfrarediProSeriesFaq';

  if (window[apiName]) {
    window[apiName].initAll();
    return;
  }

  const rootSelector = '[data-ir-pro-series-faq-root]';

  function updateIcon(root, item, expanded) {
    const picture = item.querySelector('[data-ir-pro-series-faq-icon]');
    if (!picture) return;

    const source = expanded
      ? root.dataset.irProSeriesFaqOpenIcon
      : picture.dataset.irProSeriesFaqClosedIcon;

    if (!source) return;

    picture.querySelectorAll('source').forEach((node) => {
      node.setAttribute('srcset', source);
    });

    const image = picture.querySelector('img');
    if (image) image.setAttribute('src', source);
  }

  function setExpanded(root, item, expanded, animate) {
    const trigger = item.querySelector('[data-ir-pro-series-faq-trigger]');
    const content = item.querySelector('[data-ir-pro-series-faq-content]');
    if (!trigger || !content) return;

    const state = expanded ? 'open' : 'closed';
    const openClass = trigger.dataset.irProSeriesFaqOpenClass;

    if (expanded) {
      content.hidden = false;
    }

    content.style.setProperty(
      '--ir-pro-series-faq-content-height',
      `${content.scrollHeight}px`
    );
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (openClass) trigger.classList.toggle(openClass, expanded);
    item.dataset.state = state;
    content.dataset.state = state;
    updateIcon(root, item, expanded);

    if (!animate) {
      content.hidden = !expanded;
      content.style.removeProperty('--ir-pro-series-faq-content-height');
    }
  }

  function init(root) {
    if (!root || root.dataset.irProSeriesFaqReady === 'true') return;
    root.dataset.irProSeriesFaqReady = 'true';

    root.querySelectorAll('[data-ir-pro-series-faq-item]').forEach((item) => {
      const trigger = item.querySelector('[data-ir-pro-series-faq-trigger]');
      const content = item.querySelector('[data-ir-pro-series-faq-content]');
      if (!trigger || !content) return;

      setExpanded(root, item, trigger.getAttribute('aria-expanded') === 'true', false);

      trigger.addEventListener('click', () => {
        setExpanded(
          root,
          item,
          trigger.getAttribute('aria-expanded') !== 'true',
          true
        );
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        trigger.click();
      });

      content.addEventListener('animationend', (event) => {
        if (event.target !== content) return;

        if (content.dataset.state === 'closed') {
          content.hidden = true;
        }

        content.style.removeProperty('--ir-pro-series-faq-content-height');
      });
    });
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(rootSelector)) init(scope);
    scope.querySelectorAll(rootSelector).forEach(init);
  }

  window[apiName] = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
